<style src="css/expertDetail.css" scoped></style>
<template>
    <div style="padding-top: 1rem">
<!--        <div class="topbar-wrapper">-->
<!--            <div class="topbar">-->
<!--                <span class="back" @click="back"></span>-->
<!--                {{}}-->
<!--            </div>-->
<!--        </div>-->
        <topbar :text="doctorDetail.chatDoctor.doctorName"></topbar>
        <div class="topBox">
            <div class="img" :style="{background: `url(${EnvUrl}${doctorDetail.chatDoctor.doctorWorkPhoto}) no-repeat center/cover`}"></div>
            <div class="infoRight">
                <div class="docName">{{doctorDetail.chatDoctor.doctorName}}</div>
                <div style="display: flex"><div class="zc"> <div class="zcIcon"></div><span>{{doctorDetail.chatDoctor.doctorHospitalLevel}}</span></div></div>
                <div class="offline" v-if="doctorDetail.chatDoctorServe != undefined && doctorDetail.chatDoctorServe.offline">
                    <div class="offlineIcon"></div>{{doctorDetail.chatDoctorServe.remark}}
                </div>
            </div>

        </div>
        <div class="content">
            <div class="c-contentTop">
                <div class="c-num"></div>
                <div class="topBottomBox">
                    <div class="server">
                        {{doctorDetail.chatDoctor.honor}}
                        <div>服务人数</div>
                    </div>
                    <div class="server">
                        {{doctorDetail.chatDoctor.starRate}}
                        <div>好评率(%)</div>
                    </div>
                    <div class="server">
                        {{doctorDetail.chatDoctor.thankCount}}
                        <div>感谢(个)</div>
                    </div>
                </div>
            </div>
            <div class="superiority">
                <div class="contentName">咨询师介绍</div>
                <div class="contentInfo" v-html="doctorDetail.chatDoctor.doctorProfile"></div>
                <!--<div class="contentInfo">-->
                <!--2、家庭关系：代际关系紊乱、婆媳矛盾、岳父岳母关系、父子母子关系、夫妻关系、分居、出轨、再婚家庭问题、离婚问题、挽救婚姻、小三分离。尤其是家庭结构系统紊乱，导致个体发展受限，引发各方面的心理问题。 -->
                <!--</div>-->
            </div>
            <div class="consultingBox" v-if="doctorDetail.chatDoctorServe">
                <div class="contentName">咨询方式</div>
                <div class="consultingListBox">
                    <div class="consultingList">
                        <div class="consultingItem" :class="{active:doctorDetail.chatDoctorServe.video}">
                            <div class="ciIcon ci1"></div>
                            视频咨询
                        </div>
                        <div class="consultingItem" :class="{active:doctorDetail.chatDoctorServe.telephone}">
                            <div class="ciIcon ci2"></div>
                          电话疏导
                        </div>
                        <div class="consultingItem" :class="{active:doctorDetail.chatDoctorServe.imageText}">
                            <div class="ciIcon ci3"></div>
                            图文咨询
                        </div>
                        <div class="consultingItem" :class="{active:doctorDetail.chatDoctorServe.offline}">
                            <div class="ciIcon ci4"></div>
                            线下咨询
                        </div>
                    </div>

                </div>

            </div>
            <div class="subscribeBox">
                <div class="appraiseNameBox">
                    <div class="appraiseName">可约时间</div>
<!--                    <div class="month" v-if="month">{{month}}</div>-->
                    <div class="more" @click="userBespeakAgree">全部 <span></span></div>
                </div>
                <div class="timeBox" v-if="doctorDetail.chatDoctorSchedules">
                    <div class="timeItem" :class="{active:JSON.parse(item.dateValue).length>0}" v-for="item in doctorDetail.chatDoctorSchedules" v-if="item != undefined">
                        {{item.scheduleDate | week}}
                        <span>{{item.scheduleDate | MM}}</span>
                    </div>
                </div>
            </div>

            <div class="appraise">
                <div class="appraiseNameBox">
                    <div class="appraiseName">咨询者评价</div>
                    <div class="more" @click="to(`appraiseList?doctorId=${doctorDetail.chatDoctor.doctorId}`)">全部 <span></span></div>
                </div>
                <ul class="appraiseList">
                    <li class="appraiseItem" v-for="item in doctorDetail.chatQuestionComments">
                        <div class="appraiseTop">
                            <div class="appraiseImg"></div>
                            <div>
                                <div class="appraiseItemName">匿名</div>
                                <ul class="flower">
                                    <li v-for="(v,i) in 5" :class="{active:item.star>i}"></li>
                                </ul>
                            </div>

                        </div>
                        <div class="appraiseContent" v-html="item.content"></div>
                        <ul class="appraiseBottom">
                            <li v-for="v in JSON.parse(item.tag).slice(0,2)">{{v}}</li>
                            <!--<li>讲得很清楚</li>-->
                        </ul>
                    </li>
                    <li class="appraiseMoreBox"  @click="to(`appraiseList?doctorId=${doctorDetail.chatDoctor.doctorId}`)">
                        查看全部评价
                        <div class="more"><span></span></div>
                    </li>
                </ul>

            </div>
        </div>
        <!--<div class="toBtn" @click="to(`reply?doctorId=${doctorDetail.chatDoctor.doctorId}`)">问答</div>-->
        <div class="toBtn" @click="userBespeakAgree()">预约咨询</div>
    </div>
</template>
<script>
    import {getSource, getSources} from "../api"
    import topbar from 'components/topbar'

    import noMoreData from 'components/no-more-data'
    import {serialize} from 'utils/index'
    import moment from "moment";

    export default {
        data() {
            return {
//                EnvUrl: `https://oml9ntix5.qnssl.com/`, // 七牛图片
                EnvUrl: `https://cdn.ysqingxin.com/`,
                userPhone: ``,
                userId: ``,
                month:'',
                doctorDetail:{
                    chatDoctor:{
                        doctorName:'',
                        doctorHospitalLevel:'',
                        doctorProfile:'',
                        doctorWorkPhoto:''
                    },
                },
            }
        },
        components: {
            topbar,
            noMoreData,
        },

        filters: {
            time(value) {
                let transTime = moment(value).format('YYYY-MM-DD HH:mm:ss')
                return transTime
            },
            MM(value){
                let transTime = moment(value).format('MM-DD')
                return transTime
            },
            week(value) {
                let time = moment(value).format('dddd');
                let obj = {
                    'Monday':'周一',
                    'Tuesday':'周二',
                    'Wednesday':'周三',
                    'Thursday':'周四',
                    'Friday':'周五',
                    'Saturday':'周六',
                    'Sunday':'周日'
                }
                return obj[time]
            }
        },
        computed: {},
        methods: {
            async getDoctorDetail(id) {
                let obj = {}
                obj.doctorId = id;
                obj.userId = localStorage.getItem('userId')?localStorage.getItem('userId'):'';
                let data = await getSources("/bear-scale/api/chatDoctor/getDoctorDetail.json", obj);
                if (data.status === 0) {
                    this.doctorDetail=data.doctorDetail

                    if (data.doctorDetail.chatDoctorSchedules[0] != undefined)
                      this.month=moment(data.doctorDetail.chatDoctorSchedules[0].scheduleDate).format('YYYY')+'年'+moment(data.doctorDetail.chatDoctorSchedules[0].scheduleDate).format('MM')+'月'
                }else{
                    alert(data.msg)
                }
            },
            back() {
                history.back()
            },
            async userBespeakAgree() {
              if(localStorage.getItem('userPhone')){
                this.to(`selectTime?doctorId=${this.doctorDetail.chatDoctor.doctorId}`)
              }else{
                this.to(`changePhone`)

              }

            },
            to(n) {
                this.$router.push(`/${n}`)
            },
            getCookie(key) {
                let cookieStr = document.cookie.split("; ");
                for (let i = 0; i < cookieStr.length; i++) {
                    let tempArr = cookieStr[i].split("=");
                    if (tempArr[0] == key) {
                        return tempArr[1];
                    }
                }
                return null;
            },
            setCookie: function (cname, cvalue, exdays) {
                var d = new Date();
                d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
                var expires = "expires=" + d.toUTCString();
                console.info(cname + "=" + cvalue + "; " + expires);
                document.cookie = cname + "=" + cvalue + "; " + expires;
                console.info(document.cookie);
            },
        },
        mounted() {
          if(!localStorage.getItem('userId')){
              if(this.$route.query.code){
                  this.$router.push(`/login?next=${encodeURIComponent(this.$route.fullPath)}&code=${this.$route.query.code}`)
              }else{
                  this.$router.push(`/login?next=${encodeURIComponent(this.$route.fullPath)}`)
              }
              return
          }
            this.getDoctorDetail(this.$route.query.doctorId)
            this.userId=localStorage.getItem('userId');
            this.userPhone=localStorage.getItem('userPhone');
            // this.userPhone=this.getCookie('userPhone');
            // console.log(this.userPhone)
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/expertDetail.vue?2b582b16